module.exports = __webpack_public_path__ + "img/6.b1d37378.jpg";